import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

import { BreadcrumbItem } from './models/breadcrumb-item.model';

@Injectable({
  providedIn: 'root'
})
export class BreadcrumbItemService {
  private initialPath = '';

  private root = new BehaviorSubject<BreadcrumbItem | null>(null);
  public root$ = this.root.asObservable();

  private path = new BehaviorSubject<string>(this.initialPath);
  public path$ = this.path.asObservable();

  public createRoot(id: string, label: string): BreadcrumbItem {
    const root: BreadcrumbItem = {
      children: [],
      id: id,
      isExpanded: false,
      label: label,
      order: 1,
      parent: null
    };
    this.root.next(root);

    return root;
  }

  public addChildToRoot(child: BreadcrumbItem): void {
    const root = this.root.value;
    if (!root) {
      alert('Root is null');

      return;
    }

    child.parent = root;
    root.children.push(child);
    root.children.sort((a, b) => a.order - b.order);
    this.root.next(root);
  }

  public clearChildren(parent: BreadcrumbItem): void {
    const root = this.root.value;
    if (!root) {
      alert('Root is null');

      return;
    }

    if (parent) {
      parent.children = [];
    }
  }

  public addChild(parent: BreadcrumbItem, child: BreadcrumbItem): void {
    const root = this.root.value;
    if (!root) {
      alert('Root is null');

      return;
    }
    child.parent = parent;
    parent.children.push(child);
    parent.children.sort((a, b) => a.order - b.order);
    this.root.next(root);
  }

  public getRoot(): BreadcrumbItem | null {
    return this.root.value;
  }

  public setPath(path: string): void {
    this.path.next(path);
  }

  public getPath(): string {
    return this.path.value;
  }
}
